<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_antonyms') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
            span(slot="value") {{ parameters.amountOfExamples }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfVariants') }}
            span(slot="value") {{ parameters.amountOfVariants }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
    }
</script>
